interface BadgeProps {
    className?: any,
    icon?: 'dot' | 'tag' | 'pencil' | 'eraser',
    type?: 'small' | 'large',
    label: string,
    spanClass?: string,
}

const Badge: React.FC<BadgeProps> = ({className, label, type = 'small', icon = 'tag', spanClass}) => {
    return (
        <div className={className}>
            {
                type === 'small' &&
                <span className={`inline-flex rounded px-2 py-0.5 text-xs bg-blue-100 text-blue-800 ${spanClass}`}>
                    {
                        icon === 'dot' &&
                        <svg className="mr-1 h-2 w-2" fill="currentColor" viewBox="0 0 8 8">
                            <circle cx={4} cy={4} r={3}/>
                        </svg>

                    }
                    {
                        icon === 'tag' &&
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd"
                                  d="M5.5 3A2.5 2.5 0 003 5.5v2.879a2.5 2.5 0 00.732 1.767l6.5 6.5a2.5 2.5 0 003.536 0l2.878-2.878a2.5 2.5 0 000-3.536l-6.5-6.5A2.5 2.5 0 008.38 3H5.5zM6 7a1 1 0 100-2 1 1 0 000 2z"
                                  clipRule="evenodd"/>
                        </svg>
                    }
                    {
                        icon === 'pencil' &&
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 icon icon-tabler icon-tabler-pencil" viewBox="0 0 24 24"
                             strokeWidth="1.5"
                             stroke="currentColor"
                             fill="none"
                             strokeLinecap="round"
                             strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"/>
                            <path d="M13.5 6.5l4 4"/>
                        </svg>
                    }
                    {
                        icon === 'eraser' &&
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 icon icon-tabler icon-tabler-eraser" viewBox="0 0 24 24"
                             strokeWidth="1.5" stroke="currentColor"
                             fill="none"
                             strokeLinecap="round"
                             strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <path d="M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9.2 9.3"/>
                            <path d="M18 13.3l-6.3 -6.3"/>
                        </svg>

                    }
                    {label}
                </span>
            }

            {
                type === 'large' &&
                <span className="inline-flex rounded bg-blue-100 px-2.5 py-1 text-blue-800 max-lg:text-sm">
                    {icon === 'dot' &&
                        <svg className="mr-1.5 h-4 w-4" fill="currentColor" viewBox="0 0 8 8">
                            <circle cx={4} cy={4} r={3}/>
                        </svg>
                    }
                    {
                        icon === 'tag' &&
                        <svg className="w-5 h-5 mr-1.5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd"
                                  d="M5.25 2.25a3 3 0 00-3 3v4.318a3 3 0 00.879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 005.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 00-2.122-.879H5.25zM6.375 7.5a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z"
                                  clipRule="evenodd"/>
                        </svg>
                    }
                    {label}
        </span>
            }
        </div>
    )
}
export default Badge;


